import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import Calling from '../../api/Calling'; // Make sure getAdsTxt & updateAdsTxt are here

const AdsTxtEditor = () => {
    const [loader, setLoader] = useState(false);
    const [adsTxtContent, setAdsTxtContent] = useState('');
    const [saving, setSaving] = useState(false);

    // Fetch ads.txt content
    const fetchAdsTxt = async () => {
        try {
            setLoader(true);
            const resp = await Calling.getAdsTxt();
            if (resp?.status) {
                setAdsTxtContent(resp.data || '');
            } else {
                toast.error(resp?.message || 'Failed to fetch ads.txt');
            }
        } catch (error) {
            console.error(error);
            toast.error('Server error while fetching ads.txt');
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchAdsTxt();
    }, []);

    const handleSave = async () => {
        if (!adsTxtContent.trim()) {
            toast.error('ads.txt content cannot be empty');
            return;
        }

        try {
            setSaving(true);
            const resp = await Calling.updateAdsTxt({ content: adsTxtContent });
            if (resp?.status) {
                toast.success(resp?.message || 'ads.txt updated successfully');
            } else {
                toast.error(resp?.message || 'Failed to update ads.txt');
            }
        } catch (error) {
            console.error(error);
            toast.error('Server error while updating ads.txt');
        } finally {
            setSaving(false);
        }
    };

    if (loader) return <Loader loader={loader} />;

    return (
        <div className="px-4 sm:px-6 lg:px-20 w-full mt-16 md:mt-20 bg-main-bg min-h-screen">
            <h1 className="text-2xl font-bold my-2 flex justify-between items-center text-gray-800">Edit ads.txt
                <button
                    onClick={handleSave}
                    disabled={saving}
                    className="bg-client-primary text-white px-4 text-sm py-2 rounded-lg hover:bg-blue-600 transition"
                >
                    {saving ? 'Saving...' : 'Save'}
                </button>
            </h1>

            <textarea
                value={adsTxtContent}
                onChange={(e) => setAdsTxtContent(e.target.value)}
                placeholder="Paste or edit your ads.txt content here..."
                className="w-full h-[400px] md:h-[75vh] p-4 rounded-md bg-client-font/10 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-client-primary resize-none text-sm md:text-base"
            />


        </div>
    );
};

export default AdsTxtEditor;
